import axios from 'axios';
import Toaster from 'toastr';
import Messages from '../configurations/messages';
import formUrlEncoded from 'form-urlencoded';


const request = {};

let CancelToken = axios.CancelToken;
let cancel;

let xsrfToken =  document.getElementById("csrf-token") ? document.getElementById("csrf-token").getAttribute("content"): '';
let xsrfTokenHeader = document.getElementById("csrf-token")? document.getElementById("csrf-header").getAttribute("content"): '';




// Add Session Timeout  Interceptor
axios.interceptors.response.use((response) => {
  return response;
}, (error) => {
  console.log(error);
  if (error.response
    && error.response.status === 401
    && error.response.data
    && (error.response.data.message === "SESSION_TIMEOUT" || error.response.data.code === 440)) //Session Timeout 
  {
    location.href = location.href; //Refresh page to reload/show login
    Toaster.error(Messages.SESSION_TIMEOUT);
  }
  return Promise.reject(error);


});


request.make = (ops) => {
  let options = ops || {};
  let isEnCoded = ops.encode;
  let headers = {};
  options.headers = options.headers || {};
  headers = {
    ...options.headers,
    'Content-type': isEnCoded ? 'application/x-www-form-urlencoded' : 'application/json',

  }
  headers[xsrfTokenHeader] = xsrfToken;

  const defer = new Promise(function (resolve, reject) {
    axios({
      cancelToken: new CancelToken(function executor(c) {
        cancel = c;
      }),
      url: options.url,
      method: options.method,
      headers: headers,
      baseURL: options.baseURL,
      params: options.params,
      data: isEnCoded ? formUrlEncoded(options.data || {}) : options.data || {}
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        if (axios.isCancel(error)) {
          // 
        }
        if (error.response) {
          reject(error.response)
        } else {
          reject('ERROR_NO_RESPONSE');
        }
      })
  });

  return defer;
}

request.get = (options) => {
  options.method = 'GET';
  return request.make(options);
}

request.post = (options) => {
  options.method = 'POST';
  return request.make(options);
}

request.patch = (options) => {
  options.method = 'PATCH';
  return request.make(options);
}

request.delete = (options) => {
  options.method = 'DELETE';
  return request.make(options);
}

request.cancel = () => {
  cancel && cancel();
}


export default request;



// WEBPACK FOOTER //
// ./src/api/request.js